import React, { Component } from "react";
import store from "store";
import action from "@st/activity/actions";
import { module as activity } from "@st/activity";
import { module as level } from "@st/level";
import { connectStore } from "redux-box";
import { uploadFile } from "@s/api/file";
import { Link } from "react-router-dom";
import {
  ThemeButton,
  TagChips,
  TagChipsContainer,
  ImageLoader,
  Chevron,
  DropDown,
  DropDownMenu,
  CheckBall,
  CheckBallInner,
  FlexStart,
  SubLevelItem,
  DropdownItem
} from "@sc/custom.styled";
import {
  ActivityDescriptionTextArea,
  ActivityDescription,
  FreadomPointsInputField
} from "@sc/ActivityModal.styled";
import {
  SelectFileIn,
  ImageContainer,
  ActivityUploadImageButton,
  ChangeImageButton,
  ActivityInputField
} from "@c/activity-view/activity-creation-form/ActivityCreationForm.styled";
import {
  ActivityPackDescriptionInfoContainer,
  GradeDescriptionLabel,
  ActivitySectionLabelsContainer,
  ActivityPackThemeButton,
  PackThemeButton,
  InputFieldsContainer,
  ActivityUploadImageContainer
} from "./ActivityPackInfo.styled";
import swal from "sweetalert2";
import { module as onboard } from "@st/onboard";
import Permission from "@s/permission";

class ActivityPackInfo extends Component {
  constructor(props) {
    super();
    this.state = {
      activityPackEdit: false,
      gradeLevelSelected: "",
      gradeSelected: "",
      levelSelected: "",
      levelTypeSelector: false,
      subLevelTypeSelector: false,
      backgroundImageChange: false,
      enableBackgroundImageChange: false,
      imageChange: false,
      enableLoad: false,
      file: "",
      levelData: [],
      selectedLevel: "",
      activity_pack_info: {
        name: "",
        grade_level: "",
        freadom_point: "",
        description: "",
        tag: [],
        grade: "",
        background_image: "",
        image: null
      }
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.activity && nextProps.activity.active_activity_pack) {
      this.normalizeForState(nextProps.activity.active_activity_pack);
    } else {
      this.setState({
        gradeSelected: "Select Grade"
      });
    }
  }

  normalizeForState = activeActivityPack => {
    let gradename = "Select";
    let gradeName = this.props.activity.grades.filter(grade => {
      return grade.id === activeActivityPack.grade;
    });
    if (gradeName.length > 0) gradename = gradeName[0].name;
    this.setState({
      gradeSelected: gradename,
      activity: {
        ...this.state.activity_pack_info,
        grade: activeActivityPack.grade
      }
    });
  };

  componentDidMount() {
    const data = this.props.activityPack;
    let gradename = "Select";

    let levelList = this.props.level.levels.map((level) => {
      let levelData = {
        name: level,
        selected: false,
        clicked: false,
        levels: level !== 'Level 16' ? [
          { name: "Easy", selected: false },
          { name: "Hard", selected: false },
        ] : [
          { name: "Easy", selected: false },
          { name: "Medium", selected: false },
          { name: "Hard", selected: false },
        ],
      };
      return levelData;
    });

    let gradeLevelSelected = "";
    let levelSelected = "";
    let selectedLevel = "";

    if (data.grade_level.length > 0) {
      let gradeLevels = data.grade_level.split(":");
      gradeLevelSelected = gradeLevels[0];
      levelSelected = gradeLevels[1];
      selectedLevel = data.grade_level;

      levelList = levelList.map(level => {
        if (level.name === gradeLevelSelected) {
          let subLevels = level.levels.map(subLevel => {
            if (subLevel.name === levelSelected) {
              return { ...subLevel, selected: true };
            }
            return subLevel;
          });
          return { ...level, selected: true, levels: subLevels };
        }
        return level;
      });
    }

    let gradeName = this.props.activity.grades.filter(grade => {
      return grade.id === data.grade;
    });
    if (gradeName.length > 0) gradename = gradeName[0].name;

    this.setState({
      gradeSelected: gradename,
      gradeLevelSelected: gradeLevelSelected,
      levelSelected: levelSelected,
      selectedLevel: selectedLevel,
      activity_pack_info: {
        ...this.state.activity_pack_info,
        name: data.name,
        grade: data.grade,
        description: data.description,
        tag: data.tag || [],
        grade_level: data.grade_level,
        freadom_point: data.freadom_point,
        image: data.image || null,
        background_image: data.background_image || ""
      },
      levelData: levelList
    });
  }

  handleActivityPackEdit = e => {
    this.setState({
      activityPackEdit: true
    });
  };

  _handleImageChange = e => {
    let reader = new FileReader();
    let file = e.target.files[0];
    let fileSize = e.target.files[0].size / 1024 / 1024;
    if (fileSize > 2) {
      swal("Oops!", "File size greater than 2Mb ", "warning");
    } else {
      reader.onloadend = () => {
        this.setState({
          imageChange: false,
          enableLoad: true,
          activity_pack_info: {
            ...this.state.activity_pack_info,
            image: reader.result
          }
        });
      };
      reader.readAsDataURL(file);
      uploadFile(file).then(res => {
        this.setState({
          activity_pack_info: {
            ...this.state.activity_pack_info,
            image: res.file
          },
          enableLoad: false
        });
      });
    }
  };

  handleBackgroundImageChange = e => {
    let reader = new FileReader();
    let file = e.target.files[0];
    let fileSize = e.target.files[0].size / 1024 / 1024;

    if (fileSize > 2) {
      swal("Oops!", "File size greater than 2MB ", "warning");
    } else {
      reader.onloadend = () => {
        this.setState({
          backgroundImageChange: false,
          enableBackgroundImageChange: true,
          activity_pack_info: {
            ...this.state.activity_pack_info,
            background_image: reader.result
          }
        });
      };
      reader.readAsDataURL(file);
      uploadFile(file).then(res => {
        this.setState({
          activity_pack_info: {
            ...this.state.activity_pack_info,
            background_image: res.file
          },
          enableBackgroundImageChange: false
        });
      });
    }
  };

  handleDoneBtn = () => {
    this.setState({
      activityPackEdit: false
    });
    this.props.activity.updateActivityPack(this.state.activity_pack_info);
  };

  displayGradeMenu = evt => {
    this.setState({ displayMenu: !this.state.displayMenu });
  };

  handleGradeSelected = newGrade => e => {
    this.setState({
      displayMenu: !this.state.displayMenu,
      gradeSelected: newGrade.name,
      activity_pack_info: {
        ...this.state.activity_pack_info,
        grade: newGrade.id
      }
    });
  };

  handleActivityPackNameChange = evt => {
    this.setState({
      activity_pack_info: {
        ...this.state.activity_pack_info,
        name: evt.target.value
      }
    });
  };

  handleActivityDescriptionChange = evt => {
    this.setState({
      activity_pack_info: {
        ...this.state.activity_pack_info,
        description: evt.target.value
      }
    });
  };

  handleUnlockPoints = evt => {
    if (
      evt.target.value.length === 0 &&
      this.state.activity_pack_info.freadom_point !== ""
    ) {
      this.setState({
        activity_pack_info: {
          ...this.state.activity_pack_info,
          freadom_point: ""
        }
      });
    } else
      this.setState({
        activity_pack_info: {
          ...this.state.activity_pack_info,
          freadom_point: evt.target.value
        }
      });
  };

  handleImageFocus = actionType => {
    if (actionType === "over" && this.state.imageChange === false)
      this.setState({
        imageChange: true
      });
    else if (actionType === "out" && this.state.imageChange === true)
      this.setState({
        imageChange: false
      });
  };

  handleBackgroundImageFocus = actionType => {
    if (actionType === "over" && this.state.backgroundImageChange === false)
      this.setState({
        backgroundImageChange: true
      });
    else if (actionType === "out" && this.state.backgroundImageChange === true)
      this.setState({
        backgroundImageChange: false
      });
  };

  handleLevelTypeSelector = val => {
    this.setState({
      levelTypeSelector: val
    });
  };

  handleLevelChange = (data) => {
    let newLevelData = this.state.levelData.map((level) => {
      if (level.name === data) return { ...level, clicked: !level.clicked };
      return { ...level, clicked: false };
    });
    this.setState({
      levelData: newLevelData
    });
  };

  handleSubLevelSelected = (levelName, subLevel) => {
    let newLevelData = this.state.levelData.map((level) => {
      if (level.name === levelName) {
        let subLevels = level.levels.map((subLevelOption) => {
          if (subLevelOption.name === subLevel.name) {
            this.setState({
              selectedLevel: levelName + ":" + subLevel.name,
              gradeLevelSelected: levelName,
              levelSelected: subLevel.name,
              activity_pack_info: {
                ...this.state.activity_pack_info,
                grade_level: levelName + ":" + subLevel.name
              }
            });
            return { ...subLevelOption, selected: true };
          }
          return { ...subLevelOption, selected: false };
        });
        return { ...level, selected: true, levels: subLevels };
      }
      return { ...level, selected: false, levels: level.levels.map(sl => ({ ...sl, selected: false })) };
    });

    this.setState({
      levelData: newLevelData,
      levelTypeSelector: false
    });
  };

  handleTagClick(data) {
    let activity = this.props.activity;
    const permission = this.props.onboard.permission;
    if(Permission.getPermission(permission, "change_activity")){
      activity.deletePackTag(data);
    }
  }

  render() {
    const state = this.state;
    const activity = this.props.activity;
    const permission = this.props.onboard.permission;

    return (
      <ActivityPackDescriptionInfoContainer primary>
        {!this.state.activity_pack_info.image ? (
          <ActivityUploadImageContainer>
            <ActivityUploadImageButton type="button">
              <img
                src={require("static/img/cloud-upload-icon.png")}
                alt="Upload"
              />
              <span>Upload Image </span>
            </ActivityUploadImageButton>

            <SelectFileIn
              type="file"
              onChange={(e) => this._handleImageChange(e)}
            />
          </ActivityUploadImageContainer>
        ) : this.state.enableLoad ? (
          <ActivityUploadImageContainer>
            <ImageLoader>
              {" "}
              <img
                alt="loading"
                width="40"
                height="40"
                src="http://photokonkurs.russia.travel/images/icons/preloader.gif"
              />
            </ImageLoader>
          </ActivityUploadImageContainer>
        ) : (
          <ActivityUploadImageContainer
            onMouseOver={() => this.handleImageFocus("over")}
            onMouseOut={() => this.handleImageFocus("out")}
          >
            <ImageContainer src={this.state.activity_pack_info.image} />
            {state.activityPackEdit ? (
              <ChangeImageButton
                top={this.state.imageChange ? "83%" : "100%"}
                opacity={this.state.imageChange ? 1 : 0}
              >
                Change Image
              </ChangeImageButton>
            ) : null}
            {state.activityPackEdit ? (
              <SelectFileIn
                type="file"
                onChange={(e) => this._handleImageChange(e)}
              />
            ) : null}
          </ActivityUploadImageContainer>
        )}
        {this.state.activity_pack_info.background_image === "" ? (
          <ActivityUploadImageContainer width="200px" marginLeft="14px">
            <ActivityUploadImageButton type="button">
              <img
                src={require("static/img/cloud-upload-icon.png")}
                alt="Upload"
              />
              <span> Upload Fullscreen Image </span>
            </ActivityUploadImageButton>

            {state.activityPackEdit ? (
              <SelectFileIn
                type="file"
                onChange={(e) => this.handleBackgroundImageChange(e)}
              />
            ) : null}
          </ActivityUploadImageContainer>
        ) : this.state.enableBackgroundImageChange ? (
          <ActivityUploadImageContainer width="200px" marginLeft="14px">
            <ImageLoader>
              {" "}
              <img
                alt="loading"
                width="40"
                height="40"
                src="http://photokonkurs.russia.travel/images/icons/preloader.gif"
              />
            </ImageLoader>
          </ActivityUploadImageContainer>
        ) : (
          <ActivityUploadImageContainer
            width="200px"
            marginLeft="14px"
            onMouseOver={() => this.handleBackgroundImageFocus("over")}
            onMouseOut={() => this.handleBackgroundImageFocus("out")}
          >
            <ImageContainer
              src={this.state.activity_pack_info.background_image}
            />
            {state.activityPackEdit ? (
              <ChangeImageButton
                top={this.state.backgroundImageChange ? "83%" : "100%"}
                opacity={this.state.backgroundImageChange ? 1 : 0}
              >
                Change Background
              </ChangeImageButton>
            ) : null}
            {state.activityPackEdit ? (
              <SelectFileIn
                type="file"
                onChange={(e) => this.handleBackgroundImageChange(e)}
              />
            ) : null}
          </ActivityUploadImageContainer>
        )}

        <ActivityDescription height="auto">
          {!state.activityPackEdit ? (
            <ActivitySectionLabelsContainer>
              <GradeDescriptionLabel>
                {" "}
                <span>
                  {" "}
                  {this.state.gradeLevelSelected} ( {this.state.levelSelected})
                  | Freadom Points:
                  {this.state.activity_pack_info.freadom_point}{" "}
                </span>
                {Permission.getPermission(permission, "change_activity") ? (
                  <img
                    src={require("static/img/editicon.png")}
                    alt="edit icon"
                    className="image-fluid"
                    onClick={this.handleActivityPackEdit}
                  />
                ) : null}
                {Permission.getPermission(permission, "change_activity") ? (
                  <img
                    src={require("static/img/trash.png")}
                    alt="delete icon"
                    className="image-fluid"
                  />
                ) : null}
              </GradeDescriptionLabel>
              <GradeDescriptionLabel primary>
                <Link
                  to={
                    "/activities/packs/" +
                    activity.active_grade_level +
                    "/" +
                    activity.active_level
                  }
                >
                  <ActivityPackThemeButton primary>
                    Save Changes
                  </ActivityPackThemeButton>
                </Link>
              </GradeDescriptionLabel>
            </ActivitySectionLabelsContainer>
          ) : (
            <ActivitySectionLabelsContainer>
              <InputFieldsContainer>
                <DropDown
                  minWidth="120px"
                  style={{ width: "150px" }}
                  active={this.state.levelTypeSelector}
                  onBlur={() => this.handleLevelTypeSelector(false)}
                  tabIndex="1"
                >
                  <div
                    onClick={() =>
                      this.handleLevelTypeSelector(
                        !this.state.levelTypeSelector
                      )
                    }
                  >
                    {this.state.selectedLevel.length > 0
                      ? this.state.selectedLevel
                      : "Select Level"}
                    <Chevron>
                      <img
                        src={require("static/img/downarrowicon.png")}
                        alt="down-arrow"
                      />
                    </Chevron>
                  </div>
                  <DropDownMenu
                    maxHeight="150px"
                    active={this.state.levelTypeSelector}
                    color="#fff"
                    style={{ padding: "0px" }}
                  >
                    {this.state.levelData.map((levelData, index) => (
                      <DropdownItem key={index}>
                        <FlexStart
                          style={{
                            width: "100%",
                            padding: "6px 8px",
                            position: "relative",
                            borderBottom: "solid 1px #e6e6e6",
                          }}
                          onMouseDown={(e) => e.preventDefault()}
                          onClick={() => this.handleLevelChange(levelData.name)}
                        >
                          <CheckBall
                            style={{ marginRight: "6px" }}
                            active={levelData.selected || levelData.clicked}
                          >
                            <CheckBallInner
                              active={levelData.selected || levelData.clicked}
                            />
                          </CheckBall>
                          {levelData.levels.length > 0 && (
                            <Chevron
                              cross={
                                levelData.clicked
                                  ? "rotate(0deg)"
                                  : "rotate(-90deg)"
                              }
                            >
                              <img
                                src={require("static/img/downarrowicon.png")}
                                alt="down-arrow"
                              />
                            </Chevron>
                          )}
                          {levelData.name}
                        </FlexStart>
                        {levelData.clicked &&
                          levelData.levels.length > 0 &&
                          levelData.levels.map((subLevel, i) => (
                            <SubLevelItem
                              key={i}
                              style={{
                                backgroundColor: "#faf7ff",
                                width: "100%",
                                padding: "6px 8px 6px 32px",
                                justifyContent: "flex-start",
                                borderBottom: "solid 1px #e6e6e6",
                              }}
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={() => {
                                this.handleSubLevelSelected(
                                  levelData.name,
                                  subLevel
                                );
                              }}
                            >
                              <CheckBall
                                style={{ marginRight: "6px" }}
                                active={subLevel.selected}
                              >
                                <CheckBallInner active={subLevel.selected} />
                              </CheckBall>{" "}
                              {subLevel.name}
                            </SubLevelItem>
                          ))}
                      </DropdownItem>
                    ))}
                  </DropDownMenu>
                </DropDown>
                <FreadomPointsInputField>
                  <input
                    type="number"
                    placeholder="Freadom Points"
                    value={state.activity_pack_info.freadom_point}
                    onChange={this.handleUnlockPoints}
                  />
                </FreadomPointsInputField>
              </InputFieldsContainer>
              <ThemeButton primary onClick={this.handleDoneBtn}>
                Done
              </ThemeButton>
            </ActivitySectionLabelsContainer>
          )}

          <ActivityInputField
            primary
            placeholder="New Activity Pack"
            border={
              !state.activityPackEdit ? "none" : "solid 1px rgba(40,50,112,0.1)"
            }
            id="activityPackName"
            value={state.activity_pack_info.name}
            width={state.activityPackEdit ? "75%" : "100%"}
            left={state.activityPackEdit ? "6px" : "0px"}
            onChange={this.handleActivityPackNameChange}
            disabled={!this.state.activityPackEdit}
          />
          <ActivityDescriptionTextArea
            primary={state.activityPackEdit}
            id="activityDescription"
            height={"70px"}
            max={"30px"}
            value={state.activity_pack_info.description}
            onChange={this.handleActivityDescriptionChange}
          />
          <div>
            {!state.activityPackEdit ? (
              <TagChipsContainer>
                {activity.active_activity_pack !== null
                  ? activity.active_activity_pack.tag.map((tag, i) => (
                      <TagChips
                        key={i}
                        onClick={() => this.handleTagClick(tag)}
                      >
                        {tag}
                        <img
                          className="image-fluid"
                          src={require("static/img/tagCloseIcon.png")}
                          alt="Edit icon"
                        />
                      </TagChips>
                    ))
                  : null}
                {Permission.getPermission(permission, "change_activity") ? (
                  <PackThemeButton
                    onClick={() =>
                      store.dispatch(action.setEditorType("pack_tag"))
                    }
                  >
                    + New Tag
                  </PackThemeButton>
                ) : null}
              </TagChipsContainer>
            ) : null}
          </div>
        </ActivityDescription>
      </ActivityPackDescriptionInfoContainer>
    );
  }
}

export default connectStore({
  activity,
  level,
  onboard
})(ActivityPackInfo);